// @ts-nocheck
/* Starter Sync - useOverlayBadge (modules/client-framework/src/Common/Hooks/useOverlayBadge.tsx) */

import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { BadgeImagePlacementValues, BadgeTypeValues } from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useRef } from "react";

/* Starter Custom Code - Start */
import includes from "lodash/includes";
/* Starter Custom Code - End */

/* Store Custom Code */
import { ProductListViewType } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { productCardPadding } from "@store/Themes/common/props/productCard";
/* Store Custom Code */

interface Props {
    productContext: ProductContextModel;
    showTextBadge?: boolean;
    showImageBadge?: boolean;
    styles?: { badgeTextWrapper?: InjectableCss; badgeImageWrapper?: InjectableCss };
    // Store Custom Code
    productListView?: ProductListViewType;
}

/**
 * Manages the positioning for badges that overlay a product image.
 * @param props
 */
const useOverlayBadge = ({
    productContext,
    showTextBadge,
    showImageBadge,
    styles,
    // Store Custom Code
    productListView,
}: Props) => {
    let showOverlayBadge = false;
    let overlayBadge = null;
    let overlayBadgeWrapperStyles = null;

    if (productContext.product.badges && productContext.product.badges.length > 0) {
        let visibleBadges = productContext.product.badges.filter(badge => badge.displayOnProductImages);

        if (!showImageBadge && visibleBadges.length > 0) {
            visibleBadges = visibleBadges.filter(badge => badge.badgeType !== BadgeTypeValues.Image);
        }

        if (!showTextBadge && visibleBadges.length > 0) {
            visibleBadges = visibleBadges.filter(badge => badge.badgeType !== BadgeTypeValues.Text);
        }

        if (visibleBadges.length > 0) {
            overlayBadge = visibleBadges[0];
            /* Starter Custom Code - Start */
            const { badgeType } = overlayBadge;
            const isImageBadgeType = Boolean(badgeType === BadgeTypeValues.Image);
            const isTextBadgeType = Boolean(badgeType === BadgeTypeValues.Text);
            /* Starter Custom Code - End */
            showOverlayBadge = true;
            overlayBadgeWrapperStyles = isImageBadgeType ? styles?.badgeImageWrapper : styles?.badgeTextWrapper; // Starter Custom Code
            // Starter Removed - width
            let positioning = "";

            if (overlayBadge.largeImagePlacement) {
                if (isImageBadgeType /* Starter Custom Code */) {
                    switch (overlayBadge.largeImagePlacement) {
                        case BadgeImagePlacementValues.TopLeft:
                            positioning = "left: 2%; top: 2%;";
                            break;
                        case BadgeImagePlacementValues.TopCenter:
                            positioning = `left: 50%; transform: translateX(-50%); top: 2%;`; // Starter Custom Code
                            break;
                        case BadgeImagePlacementValues.TopRight:
                            positioning = "right: 2%; top: 2%;";
                            break;
                        case BadgeImagePlacementValues.BottomLeft:
                            positioning = "left: 2%; bottom: 2%;";
                            break;
                        case BadgeImagePlacementValues.BottomCenter:
                            positioning = `left: 50%; transform: translateX(-50%); bottom: 2%;`; // Starter Custom Code
                            break;
                        case BadgeImagePlacementValues.BottomRight:
                            positioning = "right: 2%; bottom: 2%;";
                            break;
                        default:
                            positioning = "left: 2%; top: 2%;";
                    }
                }
                /* Starter Custom Code - Start */
                if (isTextBadgeType) {
                    switch (overlayBadge.largeImagePlacement) {
                        case BadgeImagePlacementValues.TopLeft:
                            positioning = `left: -${productCardPadding}; top: -${productCardPadding}; margin-right: 0;`; // Store Custom Code
                            break;
                        case BadgeImagePlacementValues.TopCenter:
                            positioning = `left: 0; right: 0; margin: 0; display: flex; justify-content: center; top: -${productCardPadding};`; // Store Custom Code
                            break;
                        case BadgeImagePlacementValues.TopRight:
                            /* Store Custom Code */
                            if (productListView === "Grid") {
                                positioning = `right: -${productCardPadding}; top: -${productCardPadding}; margin-left: 0;`;
                            } else {
                                positioning = `right: 2%; top: -${productCardPadding}; margin-left: 0;`;
                            }
                            /* Store Custom Code */
                            break;
                        case BadgeImagePlacementValues.BottomLeft:
                            positioning = `left: -${productCardPadding}; bottom: 2%; margin-left: 0;`; // Store Custom Code
                            break;
                        case BadgeImagePlacementValues.BottomCenter:
                            positioning = `left: 0; right: 0; margin: 0 2%; display: flex; justify-content: center; margin: 0 auto; bottom: 2%;`;
                            break;
                        case BadgeImagePlacementValues.BottomRight:
                            /* Store Custom Code */
                            if (productListView === "Grid") {
                                positioning = `right: -${productCardPadding}; bottom: 2%; margin-left: 0;`;
                            } else {
                                positioning = `right: 2%; bottom: 2%; margin-left: 0;`;
                            }
                            /* Store Custom Code */
                            break;
                        default:
                            positioning = `left: -${productCardPadding}; top: -${productCardPadding}; margin-right: 2%;`; // Store Custom Code
                    }
                }
                /* Starter Custom Code - End */
            }
            /* Starter Custom Code - Start */
            if (overlayBadgeWrapperStyles?.css && !includes(overlayBadgeWrapperStyles?.css, positioning)) {
                overlayBadgeWrapperStyles.css = overlayBadgeWrapperStyles.css.concat(positioning);
            }
            /* Starter Custom Code - End */
        }
    }

    const badgeAreaWrapperRef: React.MutableRefObject<HTMLDivElement | null> = useRef(null);
    const overlayBadgeWrapperClickHandler = () => {
        if (badgeAreaWrapperRef.current) {
            (badgeAreaWrapperRef.current.firstChild as HTMLLinkElement).click();
        }
    };

    return {
        showOverlayBadge,
        overlayBadge,
        overlayBadgeWrapperStyles,
        badgeAreaWrapperRef,
        overlayBadgeWrapperClickHandler,
    };
};

// eslint-disable-next-line spire/export-styles
export default useOverlayBadge;
